export enum MatrixUsage {
    None = 0,
    UserFacing = 1,
    CalculationDefaults = 2,
}
